import "./Footer.css"

function Footer () {
	return <footer>
		<div>
		Made with <span aria-label="love">💖</span> using <a href="https://create-react-app.dev/"> create-react-app</a> and <a href="https://reactjs.org/"> React</a>
		</div>
		<div>
		You can check out my projects at <a href="https://senabisshort.github.io">senabisshort.github.io</a>
		</div>
	</footer>
}

export default Footer;